import { gql } from "graphql-request";
import MainPhoto from "queries/fragments/MainPhoto";
import ParkLite from "queries/fragments/ParkLite";
import Attribute from "queries/fragments/AttractionAttribute";

const ATTRACTION_QUERY = gql`
  ${MainPhoto}
  ${ParkLite}
  ${Attribute}

  query Attraction($slug: String!) {
    attractions(where: { Slug: $slug }) {
      __typename
      id
      Slug
      Name
      Description
      Type
      Park {
        ...ParkLite
      }
      CoverPhoto {
        ...MainPhoto
      }
      MainPhoto {
        ...MainPhoto
      }
      Attribute {
        ...Attribute
      }
      Manufacturers {
        Name
        Slug
      }
      Gallery {
        ...MainPhoto
      }
      Tags {
        Name
        Slug
      }
      Location {
        Latitude
        Longitude
      }
    }
  }
`;

export default ATTRACTION_QUERY;
